module.exports = __webpack_public_path__ + "static/media/relacao.164b73e5.png";